module.exports = __webpack_public_path__ + "img/task_head_photo.8084d499.png";